import getSymbolFromCurrency from 'currency-symbol-map'
import dayjs from 'dayjs'

import { getCurrencyCode } from 'utils/formatCurrency'

export const tickFormatter = (timeStr) => {
  return dayjs(timeStr).format('DD MMM')
}

export const formatMetaTypeCodeToCurrencySign = (metaTypeCode) => {
  const code = getCurrencyCode(metaTypeCode)
  return getSymbolFromCurrency(code)
}
